import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the beneficiary to confirm. */
const beneficiaryToDeleteSignal = createSignal<number | null>(null);

export const openBeneficiaryToDelete = (beneficiaryId: number): void => {
	beneficiaryToDeleteSignal.value = beneficiaryId;
};

export const closeBeneficiaryToDelete = (): void => {
	beneficiaryToDeleteSignal.value = null;
};

export default beneficiaryToDeleteSignal;
